import type { Theme } from '@emotion/react'
import { css, keyframes } from '@emotion/react'

export const root = (width: number) => css`
  position: relative;
  width: ${width}px;
  height: ${width}px;
`

export const loader = css`
  position: absolute;
`

const spin = keyframes`
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(359deg);
  }
`

export const circle = css`
  transform-box: fill-box;
  transform-origin: center;
  animation: ${spin} 2s linear infinite;
`

export const circleBackground = (theme: Theme) => css`
  stroke: ${theme.palette.neutral[300]};
`
